import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { PageHeader, QuickFilters, DataTable, Tag } from '@NP-Webber/crm-kit/dist/next/index.js';
import api from '../../services/api.js';
import { apiError } from '../../next/ui';

/** מנויים — new design. Same endpoint as Subscriptions (/subscriptions). */
const TYPE_LABELS = { newDrasha: 'דרשה חדשה', newExam: 'מבחן חדש', gradeReady: 'ציון מוכן' };
const memberName = (m) => (m ? `${m.firstName || ''} ${m.lastName || ''}`.trim() : '');

export default function SubscriptionsNext() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [quick, setQuick] = useState('all');

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get('/subscriptions');
      setRows(res.data.data || []);
    } catch (e) {
      setError(apiError(e, 'שגיאה בטעינת מנויים'));
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const counts = useMemo(() => ({
    all: rows.length,
    active: rows.filter((r) => r.active).length,
    ivr: rows.filter((r) => r.channel === 'ivr').length,
    sms: rows.filter((r) => r.channel !== 'ivr').length,
  }), [rows]);
  const shown = useMemo(() => rows.filter((r) => (quick === 'active' ? r.active : quick === 'ivr' ? r.channel === 'ivr' : quick === 'sms' ? r.channel !== 'ivr' : true)), [rows, quick]);

  return (
    <>
      <PageHeader title="מנויים" sub={`${rows.length.toLocaleString('he-IL')} מנויים — עדכונים על דרשות, מבחנים וציונים`} more={[{ key: 'refresh', label: 'רענון', icon: 'refresh', onClick: load }]} />
      <QuickFilters
        value={quick}
        onChange={(k) => setQuick((c) => (c === k ? 'all' : k))}
        loading={loading && !rows.length}
        items={[
          { key: 'all', label: 'כל המנויים', value: counts.all, icon: 'bell', tone: 'neutral' },
          { key: 'active', label: 'פעילים', value: counts.active, icon: 'check', tone: 'success' },
          { key: 'ivr', label: 'IVR', value: counts.ivr, icon: 'phone', tone: 'info' },
          { key: 'sms', label: 'SMS', value: counts.sms, icon: 'mail', tone: 'violet' },
        ]}
      />
      <DataTable
        mode="client"
        rows={shown}
        rowKey="_id"
        loading={loading}
        error={error}
        onRetry={load}
        onRefresh={load}
        selectable={false}
        storageKey="bchinot-subscriptions"
        exportFilename="מנויים"
        searchPlaceholder="חיפוש לפי שם חבר…"
        emptyTitle="אין מנויים"
        columns={[
          { key: 'memberId', label: 'חבר', getValue: (r) => memberName(r.memberId) || '—', render: (r) => <b>{memberName(r.memberId) || '—'}</b> },
          { key: 'type', label: 'סוג', type: 'enum', getValue: (r) => TYPE_LABELS[r.type] || r.type },
          { key: 'channel', label: 'ערוץ', type: 'enum', getValue: (r) => (r.channel === 'ivr' ? 'IVR' : 'SMS'), render: (r) => <Tag tone={r.channel === 'ivr' ? 'info' : 'violet'} icon={r.channel === 'ivr' ? 'phone' : 'mail'}>{r.channel === 'ivr' ? 'IVR' : 'SMS'}</Tag> },
          { key: 'active', label: 'פעיל', type: 'bool', getValue: (r) => !!r.active, render: (r) => (r.active ? <Tag tone="success" icon="check">פעיל</Tag> : <Tag>לא פעיל</Tag>) },
        ]}
      />
    </>
  );
}
